import { create } from 'zustand';
import { SearchQuestionItem, searchQuestionService } from '@mygpt/app/chat/services';

interface QuestionSuggestionState {
  loading: boolean;
  questionSuggestions: SearchQuestionItem[];
  searchQuestion: (params: Parameters<typeof searchQuestionService>[0]) => Promise<void>;
  clear: () => void;
}

export const useQuestionSuggestion = create<QuestionSuggestionState>((set) => ({
  loading: false,
  questionSuggestions: [],
  searchQuestion: async (params) => {
    set({ loading: true });
    try {
      const res = await searchQuestionService(params);
      set({ questionSuggestions: res.data });
    } catch (error) {
      console.error(`searchQuestion error: ${error}`);
    } finally {
      set({ loading: false });
    }
  },
  clear: () => set({ questionSuggestions: [] }),
}));
